import { RenderFunction } from '../types';
import { LikerScaleRender } from './LikerScaleRender';
import { SchoolNameRender } from './SchoolNameRender';

const cellRenderers = {
  likert: LikerScaleRender,
  schoolNameRender: SchoolNameRender,
};

export * from './LikerScaleRender';
export * from './SchoolNameRender';

export type RenderComponentType = keyof typeof cellRenderers;

export function getCellRenderer(
  component: RenderComponentType | RenderFunction,
): RenderFunction<any, any, any> {
  if (typeof component === 'string') {
    return cellRenderers[component];
  }

  return component;
}
